export const theme = {
  closeButtonBoxShadow: Styles.boxShadow,
  modalContentBackground: Styles.color.grey.five,
  modalWrapperBackground: Styles.color.white,
};
